export const armenianLettersRegex = /^[Ա-Ֆա-ֆ։֊\s-]+$/;
export const armenianUnicodeMachRegex = /[^\u0531-\u058F\u0561-\u0587\s-]/g;

export const isArmenianLetter = (letter: string) => armenianLettersRegex.test(letter);
